module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-t-mobile-intro-card1.1@2x.63c7b4a0.jpg";